import React from "react";

function RegisterPage() {
  return <div>Register page</div>;
}

export default RegisterPage;
